import { QUERY_KEY } from 'config'

export default function pagingParametersFromQuery(query) {
  const page = query[QUERY_KEY.PAGE]

  return page ?? 1
}
